var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79514 17.5C8.38275 18.0186 9.15462 18.3333 10 18.3333C10.8454 18.3333 11.6172 18.0186 12.2048 17.5M15 6.66663C15 5.34054 14.4732 4.06877 13.5355 3.13109C12.5978 2.19341 11.3261 1.66663 10 1.66663C8.67391 1.66663 7.40214 2.19341 6.46446 3.13109C5.52678 4.06877 5 5.34054 5 6.66663C5 9.24178 4.35039 11.0049 3.62472 12.1711C3.0126 13.1549 2.70654 13.6467 2.71777 13.7839C2.73019 13.9359 2.76238 13.9938 2.88481 14.0846C2.99538 14.1666 3.49382 14.1666 4.49071 14.1666H15.5093C16.5062 14.1666 17.0046 14.1666 17.1152 14.0846C17.2376 13.9938 17.2698 13.9359 17.2822 13.7839C17.2934 13.6467 16.9874 13.1549 16.3753 12.1711C15.6496 11.0049 15 9.24178 15 6.66663Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.fbb0396a86a23ad45c8be88f61484821.svg";
export { ForwardRef as ReactComponent };